// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1_ogL","cls2":"RelatedPapers-cls2_t1J RelatedPapers-cls1_ogL"};